import React from "react";
import "./Pager.css";

export const Pager = ({
  currentPage,
  currentPageSetter,
  maxPageCount,
  currentPageSetterIncrease,
  currentPageSetterDecrease,
}) => {
  return (
    <ul className="pager-component">

      <li className="pager-item">
        <div
          className="pager-button"
          onClick={() => currentPageSetterDecrease()}
        >
          {'<'}
        </div>
      </li>

      {/* First pager item */}
      <li className="pager-item">
        <div
          className={"pager-link " + ((currentPage === 1 && "active") || "")}
          value={1}
          onClick={(e) => currentPageSetter(e)}
        >
          1
        </div>
      </li>

      {/* Add space if more than 3 */}
      {maxPageCount > 3 && currentPage > 3 && <div className="pager-spacing">...</div>}

      {/* if 1 or 2 is selectet - show 2 and 3*/}
      {maxPageCount > 2 && (currentPage === 1 || currentPage === 2) && (
        <>
          <li className="pager-item">
            <div
              className={"pager-link " + ((currentPage === 2 && "active") || "")}
              value={2}
              onClick={(e) => currentPageSetter(e)}
            >
              {2}
            </div>
          </li>

        {maxPageCount > 3 && (
          <li className="pager-item">
            <div
              className={"pager-link " + ((currentPage === 3 && "active") || "")}
              value={3}
              onClick={(e) => currentPageSetter(e)}
            >
              {3}
            </div>
          </li>
        ) }
        </>
      )}

      {currentPage >= 3 && maxPageCount - currentPage >= 0 && (
        
        <>
          <li className="pager-item">
            <div
              className="pager-link"
              value={currentPage - 1}
              onClick={(e) => currentPageSetter(e)}
            >
              {currentPage - 1}
            </div>
          </li>

          {maxPageCount - currentPage !== 0 && (
            <li className="pager-item">
              <div
                className="pager-link active"
                value={currentPage}
                onClick={(e) => currentPageSetter(e)}
              >
                {currentPage}
              </div>
            </li>
          )}

          {maxPageCount > 4 && maxPageCount - currentPage !== 1 && maxPageCount - currentPage > 1 && (
            <li className="pager-item">
              <div
                className="pager-link"
                value={currentPage + 1}
                onClick={(e) => currentPageSetter(e)}
              >
                {currentPage + 1}
              </div>
            </li>
          )}
        </>
      )}

      {maxPageCount > 4 && maxPageCount - currentPage > 2 && (
        <div className="pager-spacing">...</div>
      )}

      {/* Last pager item */}
      {
        maxPageCount > 1 && (
          <li className="pager-item">
            <div
              className={
                "pager-link " +
                ((maxPageCount - currentPage === 0 && "active") || "")
              }
              value={maxPageCount}
              onClick={(e) => currentPageSetter(e)}
            >
              {maxPageCount}
            </div>
          </li>
        )
      }

      <li className="pager-item">
        <div
          className="pager-button"
          onClick={() => currentPageSetterIncrease()}
        >
          {'>'}
        </div>
      </li>

    </ul>
  );
};
